import { render, staticRenderFns } from "./my_class.vue?vue&type=template&id=5cfc4a28"
import script from "./my_class.vue?vue&type=script&lang=js"
export * from "./my_class.vue?vue&type=script&lang=js"
import style0 from "./my_class.vue?vue&type=style&index=0&id=5cfc4a28&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports